/**
 * @generated SignedSource<<0fc83163cf3bc7eef288aa6ad7b96d20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ComponentType = "CHECKIN" | "HABIT" | "LESSON" | "MESSAGE" | "WORKOUT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CoachClientCalendar_enrollments$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly activities: ReadonlyArray<{
        readonly component: {
          readonly type: ComponentType;
        } | null | undefined;
        readonly date: string | null | undefined;
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"CoachClientCalendarActivity_activity">;
      } | null | undefined>;
      readonly id: string;
      readonly program: {
        readonly name: string;
      };
      readonly startDate: string | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"CoachClientCalendarEnrollment_enrollment">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ChooseProgramEnrollDialog_enrollments">;
  readonly " $fragmentType": "CoachClientCalendar_enrollments";
};
export type CoachClientCalendar_enrollments$key = {
  readonly " $data"?: CoachClientCalendar_enrollments$data;
  readonly " $fragmentSpreads": FragmentRefs<"CoachClientCalendar_enrollments">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "raw",
    "value": true
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CoachClientCalendar_enrollments",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EnrollmentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Enrollment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": (v1/*: any*/),
              "kind": "ScalarField",
              "name": "startDate",
              "storageKey": "startDate(raw:true)"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Program",
              "kind": "LinkedField",
              "name": "program",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Activity",
              "kind": "LinkedField",
              "name": "activities",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": (v1/*: any*/),
                  "kind": "ScalarField",
                  "name": "date",
                  "storageKey": "date(raw:true)"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Component",
                  "kind": "LinkedField",
                  "name": "component",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CoachClientCalendarActivity_activity"
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CoachClientCalendarEnrollment_enrollment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChooseProgramEnrollDialog_enrollments"
    }
  ],
  "type": "EnrollmentConnection",
  "abstractKey": null
};
})();

(node as any).hash = "cbcd77f4d96bfffbf4a2a44a6a748c37";

export default node;
